import { useMemo } from 'react';
import { useRepositoryQuery } from '@mews-commander/data-access';
import { getAppDateTimeNow } from '@mews-commander/utils';
import { DateTimeService, useAppClockService, useTimezone } from '@mews/framework';

export const useTaxEnvironmentData = () => {
    const { data, isLoading } = useRepositoryQuery('globalization', 'get', {});
    const timezone = useTimezone();
    const appClockService = useAppClockService();
    const now = getAppDateTimeNow({ appClockService, timezone });
    const taxEnvironmentData = useMemo(() => {
        if (!data) return;
        return data.legalEnvironments
            ?.filter((te) => {
                if (te.validityEndUtc) {
                    const endDate = DateTimeService.fromUtcString(te.validityEndUtc, timezone);
                    const today = DateTimeService.startOfDay(now);
                    return endDate > today;
                }
                return true;
            })
            .map((le) => {
                const country = data.countries?.find((c) => c.code === le?.countryCode);
                const taxEnvironments = data.taxEnvironments.find(
                    (te) => te.code === le.code || te.code === le.countryCode
                );
                const taxations = taxEnvironments?.taxationCodes.map(
                    (tc) => data.taxations?.find((t) => t.code === tc)
                );
                const depositTaxRateMode = taxEnvironments?.defaultSettlementDepositTaxRateMode;
                return {
                    ...le,
                    country: country?.englishName,
                    depositTaxRate: depositTaxRateMode,
                    taxations,
                };
            })
            .sort((a, b) => {
                const nameA = a.englishName ?? '';
                const nameB = b.englishName ?? '';

                return nameA.localeCompare(nameB);
            });
    }, [data, now, timezone]);

    return {
        taxEnvironmentData,
        isLoading,
    };
};
